<template>
  <StructuredText
    :class="bem({'bgColour': props.bgColour})"
    :data="props.heading.value"
    :custom-rules="customRules"
  />
</template>

<script setup>
import { StructuredText, renderRule } from 'vue-datocms'
import { isParagraph, isSpan } from 'datocms-structured-text-utils'

const bem = useBEM('CardScrollerRevealTitle')

const props = defineProps({
  heading: {
    type: Object,
    required: true,
  },
  bgColour: {
    type: String,
    required: false,
    default: 'black'
  }
})
  
const customRules = computed(() => {
  return [
    renderRule(
      isParagraph,
      ({ adapter: { renderNode: h }, children, key }) => {
        return h(
          'span',
          { key },
          children
        )
      }
    ),
    renderRule(isSpan, ({ adapter: { renderNode: h }, node, key }) => {
      if (
        node.marks &&
        node?.marks.includes('highlight')
      ) {
        return h('span', { key, class: 'CardScrollerRevealTitle__title-fill-area CardScrollerRevealTitle__title-fill-area--gradient' }, node.value)
      }

      return h('span', { key, class: 'CardScrollerRevealTitle__title-fill-area CardScrollerRevealTitle__title-fill-area--normal' }, node.value)
    }),
  ]
})
</script>

<style lang="postcss">
.CardScrollerRevealTitle--bg-colour-white {
  .CardScrollerRevealTitle__title-fill-area {
    -webkit-text-fill-color: rgba(0, 0, 0, 0.1);
  }

  .CardScrollerRevealTitle__title-fill-area--normal {
    background-image: linear-gradient(#000, #000);
  }
}

.CardScrollerRevealTitle__title-fill-area {
  @apply relative inline;

  -webkit-text-fill-color: rgba(255, 255, 255, 0.1);
  -webkit-background-clip: text;
  background-repeat: no-repeat;
  background-size: 0% 100%;
}

.CardScrollerRevealTitle__title-fill-area--normal {
  background-image: linear-gradient(#fff, #fff);
}

.CardScrollerRevealTitle__title-fill-area--gradient {
  background-image: linear-gradient(70deg, #5c0f99, #3449b8 60%, #1799e1);
}
</style>